import openStepUp from '@/components/auth/step-up/open.step.up';
import stepUpHandler from '@/lib/beauth/step.up.handler';
import { realtimeReconnect } from '@/lib/socket/socket.manager';

export default function stepUpRegister(): () => void {
    return stepUpHandler.register(async () => {
        const confirmed = await openStepUp();
        if (confirmed) realtimeReconnect();
        return confirmed;
    });
}
